import * as React from 'react';
import * as FocusTrap from "focus-trap-react";
import {observer} from "mobx-react";
import {action, computed} from "mobx";
import {UIState} from "../../../data/UIState";
import {BadgeCard} from "components/badges/BadgeCard";
import './BadgeAchievedConfetti.pcss';
import {DateTimeHelpers} from "shared/DateTimeHelpers";
import {DateTime} from "luxon";

interface Props {
}

@observer
export class BadgeAchievedConfetti extends React.Component<Props> {
  @computed get show() {
    return UIState.feedData && UIState.feedData.showBadgeEarnedConfetti
  }

  @action clear = () => {
    UIState.feedData.showBadgeEarnedConfetti = false;
  }

  render() {
    if(!this.show) {
      return null;
    }

    const solution = UIState.feedData.solution;
    return (
      <div className={"badge-achieved-modal"}>
        <FocusTrap focusTrapOptions={
          {
            allowOutsideClick: false,
            clickOutsideDeactivates: true,
            onDeactivate:()=>{ this.clear(); },
          }
        }>
          <div role="alert" onClick={(e) => {
            e.stopPropagation();
          }}>
            <h1>You've just earned the Badge!</h1>
            <div className={"badgeCard"}>
              <div className={"solution-badge"}><img src={solution.badge} alt={`Badge earned`}/></div>
              <div className={"solution-badge-info"}>
                <h3>{solution.name}</h3>
                <p className={"date"}>{DateTime.now().toFormat("LLLL yyyy")}</p>
                <p>{UIState.feedData.pointsDataSource.points} points</p>
              </div>
            </div>
            <button onClick={this.clear}>Ok</button>
          </div>
        </FocusTrap>
      </div>

    );
  }
}

